import * as L from 'leaflet';
import { KeyedCollection } from "../collections/dictionary";

export class GpsLocation {
	lat: number;
	lng: number;
}

export interface IMapConfig {
	location: GpsLocation;
	zoom: number;
	minZoom: number;
}

export class LeafletMap {
	imap: L.Map;
	control: L.LayerControl;
	markers: KeyedCollection<any> = new KeyedCollection<any>();
	overlays = {
		//Wind: L.tileLayer('http://{s}.tile.openweathermap.org/map/wind/{z}/{x}/{y}.png?appid={apiKey}', {
		//	maxZoom: 19,
		//	attribution: 'Map data &copy; <a href="http://openweathermap.org">OpenWeatherMap</a>',
		//	apiKey: 'YOURAPIKEY',
		//	opacity: 0.5
		//}),
		//Clouds: L.tileLayer('http://{s}.tile.openweathermap.org/map/clouds/{z}/{x}/{y}.png?appid={apiKey}', {
		//	maxZoom: 19,
		//	attribution: 'Map data &copy; <a href="http://openweathermap.org">OpenWeatherMap</a>',
		//	apiKey: 'YOURAPIKEY',
		//	opacity: 0.5
		//}),
		//Pressure: L.tileLayer('http://{s}.tile.openweathermap.org/map/pressure/{z}/{x}/{y}.png?appid={apiKey}', {
		//	maxZoom: 19,
		//	attribution: 'Map data &copy; <a href="http://openweathermap.org">OpenWeatherMap</a>',
		//	apiKey: 'YOURAPIKEY',
		//	opacity: 0.5
		//})
	};
	//// https://leaflet-extras.github.io/leaflet-providers/preview/
	//L.tileLayer.provider("HERE.terrainDay", {
	//	app_id: "D8a9nIOBglilzF4GY2C6",
	//	app_code: "6z3c2e-KA3e6rbujMitpfQ"
	//}).addTo(map);

	baseLayers = {
		
		Terrain: L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
			maxZoom: 21,
			attribution:
				'Map data: &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
		}),
		Satellite: L.tileLayer(
			'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
			
			{
				maxZoom: 19,
				attribution:
					'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
			}
		)
	};

	constructor(id: string, descriptor: IMapConfig, activeLayer = '') {
		let defaultLayer = this.baseLayers.Terrain;
		if (activeLayer) {
			defaultLayer = this.baseLayers[activeLayer];
		}
		this.imap = L.map(id, {
			center: [descriptor.location.lat, descriptor.location.lng],
			zoom: descriptor.zoom,
			minZoom: descriptor.minZoom,
			zoomControl: false,
			layers: [defaultLayer]
		});

		L.control.scale().addTo(this.imap);

	}

	addLayer(title: string, layer: L.Layer) {
		this.overlays[title] = layer;
		this.imap.addLayer(layer);
	}

	addLayerGroup(title: string) {
		this.overlays[title] = L.layerGroup([]);
		this.imap.addLayer(this.overlays[title]);
	}

	centerLeafletMapOnMarker(map, marker) {
		const latLngs = [marker.getLatLng()];
		const markerBounds = L.latLngBounds(latLngs);
		map.fitBounds(markerBounds);
	}



	showLayerControl() {
		this.control = L.control.layers(this.baseLayers, this.overlays).addTo(this.imap);
	}

	showZoomControl(position = 'topleft') {
		L.control
			.zoom({
				position: position
			})
			.addTo(this.imap);
	}

	moveTo(zoom: number, location: GpsLocation) {
		this.imap.setZoom(zoom);
		this.imap.panTo(new L.LatLng(location.lat, location.lng));
	}

	zoomTo(location: GpsLocation) {
		this.imap.setView(new L.LatLng(location.lat, location.lng), 8);
	}


	addMarker(location: GpsLocation, markerId: string, popupText = '', layerTitle = 'default', icon: any = null, ) {
		let group: L.LayerGroup;

		const marker = (icon) ? L.marker([location.lat, location.lng], { icon: icon }) : L.marker([location.lat, location.lng]);

		const this_ = this;
		//marker.on('click',
		//	() =>  {
		//		this_.centerLeafletMapOnMarker(this_.imap, marker);
		//	});

		this.markers.add(markerId, marker);
		if (popupText) {

			const popup = L.popup({ autoClose: true, closeOnClick: true });
			popup.setContent(popupText);
			marker.bindPopup(popup);
		}
		if (!this.overlays[layerTitle]) {
			group = L.layerGroup([]);
			this.overlays[layerTitle] = group;
			this.imap.addLayer(group);
		} else {
			group = this.overlays[layerTitle] as L.LayerGroup;
		}
		marker.addTo(group);
	}

	removeMarker(marker: L.Marker) {
		marker.removeFrom(this.imap);
	}

	//removeMarkers(layerTitle = 'Default') {
	//	let group = this.overlays[layerTitle] as L.LayerGroup;
	//	this.imap.removeLayer(group);
	//	this.overlays[layerTitle] = L.layerGroup([]);
	//	this.imap.addLayer(this.overlays[layerTitle]);
	//}

	invalidateSize() {
		this.imap.invalidateSize();
		let hiddenMethodMap = this.imap as any;
		hiddenMethodMap._onResize();
	}
}